import { ASSIGNMENTS } from 'constants/actionTypes';

const initialState = {
  bulkPermissions: {
    canBulkMarkComplete: false,
    canBulkRemind: false,
    canBulkReassign: false,
  },
  isCurrentAssignableExist: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case ASSIGNMENTS.DIRECT_ASSIGN.RECEIVE:
      return {
        bulkPermissions: action.bulkPermissions,
        isCurrentAssignableExist: action.isCurrentAssignableExist,
      };
    default:
      return state;
  }
};
